import { useRemoveAccountMedication } from "@tandemdiabetes/sugarmate-api-react-client"
import { transformAccountMedication } from "./transformAccountMedication"
import { useDeleteCollectionItem } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useDeleteAccountMedication() {
  return useDeleteCollectionItem(
    CollectionKey.AccountMedication,
    "account_med",
    useRemoveAccountMedication,
    transformAccountMedication,
  )
}
